import React from 'react';
import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import FlexContainer from '@components/Gui/FlexContainer';
import NwDrawer from '@components/Gui/NwDrawer';
import NwIcon from '@components/Gui/NwIcon';
import ProjectPage from '@components/Project/ProjectPage';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Actions = styled(FlexContainer)`
    svg {
        margin-left: 8px;
    }
`;

const ProjectDrawer = ({ projectId, onClose }) => {
    const breakpoints = useNwBreakPoints();
    const navigate = useNavigate();

    const handleMoveProjectDetails = () => {
        navigate(`/bookings/${projectId}`);
    };

    return (
        <NwDrawer
            width={'90vw'}
            title={
                <FlexContainer justifyContent="space-between">
                    <div>Project Preview</div>
                    {breakpoints > 3 && (
                        <Actions>
                            <NwIcon
                                icon={byPrefixAndName.fass['expand-wide']}
                                pointer
                                onClick={handleMoveProjectDetails}
                                size="lg"
                            />
                        </Actions>
                    )}
                </FlexContainer>
            }
            onClose={onClose}
            whiteBg={false}
            padding={breakpoints < 4 ? '0' : '24px'}
        >
            <ProjectPage isdrawer={true} projectId={projectId} onClose={onClose} />
        </NwDrawer>
    );
};

export default ProjectDrawer;
